module.exports = __webpack_public_path__ + "static/media/cocaul-face.14bbee42.jpg";